import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { uiActions } from "../store/ui/ui-slice";
import { postFetchAxios } from "../Services/commonService";
import { API_CHECK_AUTH } from "../utils/api/ApiConstant";
import { Loading } from "../Components";
import { userAction } from "../store/user/user-slice";

const ProtectedRoute = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { token, userId } = useSelector(
    (state) => ({
      token: state.user.token,
      userId: state.user.user?.userId,
    }),
    shallowEqual,
  );

  useEffect(() => {
    dispatch(uiActions.setLoading(false));
    dispatch(uiActions.setFormSubmitLoading(false));
    dispatch(userAction.setSubscribeTokens([]));
  }, [dispatch]);

  const { isLoading, data, isFetching, isError } = useQuery({
    queryKey: ["checkAuthData", token, location.pathname],
    queryFn: async () => {
      return await postFetchAxios({
        url: API_CHECK_AUTH,
        payload: { userId, token },
      });
    },
    enabled: !!token,
    staleTime: 0,
    cacheTime: 0,
    retry: false,
  });

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (isLoading) {
    return <Outlet context={{ isAuthChecking: true }} />;
  }

  if (isError || !data) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet context={{ isAuthChecking: isFetching }} />;
};

export default ProtectedRoute;
